module.exports = __webpack_public_path__ + "img/283.1993a801.jpg";